module.exports = [
	{
		"url": "https://help.remind.com/hc/en-us/articles/203179827",
		"title": "Can I add an owner to my class?",
		"body": "Yes you can add an owner to your classes in your account. Here's how you will promote them to owner:"
	},
	{
		"url": "https://help.remind.com/hc/en-us/articles/203179817",
		"title": "How do I remove participants?",
		"body": "If a student/parent is no longer in your class and you want to remove him/her from your Remind messages, you can easily do that within your account."
	},
	{
		"url": "https://help.remind.com/hc/en-us/articles/202171035",
		"title": "Can I update my account details?",
		"body": "As a teacher/organizer, the easiest way to update or change your account information is to log into your Remind account online and go to Settings in the lower left."
	},
	{
		"url": "https://help.remind.com/hc/en-us/articles/202004015",
		"title": "I can't access my account!",
		"body": "Try clicking \"Forgot password?\" underneath where you sign in. You'll receive an email with a password reset link to access your account again."
	},
	{
		"url": "https://help.remind.com/hc/en-us/articles/203179887-How-do-I-join-a-class",
		"title": "How do I join a class?",
		"body": "There are 3 ways to receive messages on Remind. You can receive messages via text, email, or push notification (or any combination of these)."
	},
	{
		"url": "https://help.remind.com/hc/en-us/articles/202547989",
		"title": "How do I get participants?",
		"body": "New participants need to use your unique class @code and then follow all prompts (e.g. - reply with full name if first time joining a class)."
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/support/constants/DefaultArticles.json
// module id = 2209
// module chunks = 0 1